(function () {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  window.RotaTheme?.register('mega-menu', {
    init(root) {
      const panelRoot = root.querySelector('[data-mega-menu-panel-root]');
      const triggers = Array.from(root.querySelectorAll('[data-mega-menu-trigger]'));
      if (!panelRoot || triggers.length === 0 || root.dataset.megaMenuEnabled !== 'true') return null;

      let overlay = null;
      let activeTrigger = null;
      const cleanups = [];

      const setActivePanel = (id) => {
        panelRoot.querySelectorAll('[data-mega-menu-panel]').forEach((panel) => {
          panel.hidden = panel.id !== id;
        });
      };

      const close = ({ restoreFocus = true } = {}) => {
        overlay?.close({ restoreFocus });
        activeTrigger?.setAttribute('aria-expanded', 'false');
        activeTrigger?.removeAttribute('aria-current');
        activeTrigger = null;
      };

      const open = (trigger) => {
        const panelId = trigger.getAttribute('aria-controls');
        if (!panelId) return;
        close({ restoreFocus: false });
        activeTrigger = trigger;
        trigger.setAttribute('aria-expanded', 'true');
        trigger.setAttribute('aria-current', 'true');
        setActivePanel(panelId);
        overlay = window.RotaOverlay?.create({
          panel: panelRoot,
          trigger,
          modal: false,
          lockBodyScroll: true,
          onClose: () => {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.removeAttribute('aria-current');
          },
        });
        overlay?.open();
      };

      triggers.forEach((trigger) => {
        const handleClick = (event) => {
          if (!desktopQuery.matches) return;
          event.preventDefault();
          if (activeTrigger === trigger && overlay?.isOpen()) close();
          else open(trigger);
        };
        trigger.addEventListener('click', handleClick);
        cleanups.push(() => trigger.removeEventListener('click', handleClick));
      });

      const handleKeydown = (event) => {
        if (event.key !== 'Escape') return;
        const trigger = activeTrigger;
        close();
        trigger?.focus({ preventScroll: true });
      };
      const handleResize = () => {
        if (!desktopQuery.matches) close({ restoreFocus: false });
      };
      const handleMobileOpen = () => close({ restoreFocus: false });

      root.addEventListener('keydown', handleKeydown);
      desktopQuery.addEventListener('change', handleResize);
      document.addEventListener('rm:mobile-navigation:open', handleMobileOpen);
      cleanups.push(() => root.removeEventListener('keydown', handleKeydown));
      cleanups.push(() => desktopQuery.removeEventListener('change', handleResize));
      cleanups.push(() => document.removeEventListener('rm:mobile-navigation:open', handleMobileOpen));

      return () => {
        close({ restoreFocus: false });
        cleanups.forEach((cleanup) => cleanup());
      };
    },
  });
})();
